/**
 * Cookie Policy Route (Epic 33, Story 33-2).
 *
 * Renders the Iubenda auto-generated cookie policy via `IubendaPolicyEmbed`.
 * Until the Iubenda ids are provisioned (see docs/EXTERNAL-PROVISIONING-TODO.md)
 * the embed falls back to a pointer at the static Story-0.7 /privacy page, so
 * the route is always live. Per ADR-0005 the Iubenda-generated policy will, once
 * provisioned, supersede the static Section 9 cookie table in /privacy.
 */

import { createFileRoute, Link, useRouter } from "@tanstack/react-router";
import { Card, CardContent } from "@provenleap/ui";
import { IubendaPolicyEmbed } from "../components/compliance/IubendaPolicyEmbed";
import { useSEO } from "../hooks/useSEO";
import { SEO_CONFIG } from "../seo/seoConfig";

export const Route = createFileRoute("/cookie-policy")({
  component: CookiePolicyPage,
});

function CookiePolicyPage() {
  const router = useRouter();

  // Title/description/canonical/OG with cleanup (Story 30.2 useSEO).
  useSEO(SEO_CONFIG["/cookie-policy"]!);

  return (
    <div id="top" className="min-h-screen bg-white p-4 sm:p-8">
      <div className="max-w-[800px] mx-auto">
        <div className="flex items-center gap-4 mb-4">
          <button
            type="button"
            onClick={() => {
              if (window.history.length > 1) {
                router.history.back();
              } else {
                router.navigate({ to: "/login" });
              }
            }}
            className="text-sm text-muted-foreground hover:underline inline-block cursor-pointer"
          >
            &larr; Back
          </button>
          <span className="text-sm text-muted-foreground">|</span>
          <Link
            to="/privacy"
            className="text-sm text-muted-foreground hover:underline inline-block"
          >
            See also our Privacy Policy
          </Link>
        </div>

        <article>
          <Card>
            <CardContent className="pt-6">
              <header className="mb-8">
                <h1 className="text-2xl font-semibold mb-2">Cookie Policy</h1>
                <p className="text-sm text-muted-foreground">
                  How ProvenLeap uses cookies and client-side storage, and how you
                  control consent.
                </p>
              </header>

              <IubendaPolicyEmbed kind="cookie" title="Cookie Policy" />
            </CardContent>
          </Card>
        </article>
      </div>
    </div>
  );
}
